module.exports = __webpack_public_path__ + "img/ThatsLife.1a330a15.jpg";